module.exports = __webpack_public_path__ + "static/img/eboard-factory2.168d3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eboard-factory2.png
// module id = GrNn
// module chunks = 1